import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Icon } from "../../components/Icon";
import Minus from "../../icons/minus.svg";
import Plus from "../../icons/plus.svg";
import styles from "./CountInput.module.scss";
export const CountInput = ({ onChange, count, testId, testIdMinus = "count-input-decrease-button", testIdPlus = "count-input-increase-button", isNegativeAllowed = true, minimumAllowedQuantity = 0, isLimitReached = false, }) => {
    const [isMinusDisabled, setIsMinusDisabled] = useState(false);
    const [isPlusDisabled, setIsPlusDisabled] = useState(false);
    const increaseValue = () => {
        !isPlusDisabled && onChange(count + 1, { action: "increase" });
    };
    const decreaseValue = () => {
        !isMinusDisabled && onChange(count - 1, { action: "decrease" });
    };
    useEffect(() => {
        setIsMinusDisabled(!isNegativeAllowed && count <= minimumAllowedQuantity);
        setIsPlusDisabled(isLimitReached);
    }, [count, isLimitReached, isNegativeAllowed, minimumAllowedQuantity]);
    return (_jsxs("div", { className: styles.countInput, "data-testid": testId ?? "countInput", children: [_jsx("button", { onClick: decreaseValue, className: styles.countInputButton, "data-testid": testIdMinus, "aria-disabled": isMinusDisabled, disabled: isMinusDisabled, type: "button", children: _jsx(Icon, { component: Minus, "aria-label": "step-backward" }) }), _jsx("div", { className: styles.countInputValue, children: count }), _jsx("button", { onClick: increaseValue, className: styles.countInputButton, "data-testid": testIdPlus, "aria-disabled": isPlusDisabled, disabled: isPlusDisabled, type: "button", children: _jsx(Icon, { component: Plus, "aria-label": "step-forward" }) })] }));
};
//# sourceMappingURL=CountInput.js.map